import { Box, Card, Grid, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import styles from './styles';
import EirSingleCardimage from './EirSingleCardImage';
import EirSingleCardBody from './EirSingleCardBody';
import EirSingleOfferCardFooter from './EirSingleOfferCardFooter';

const EirSingleOfferCard = ({
  topTag,
  offerSelected,
  moreInfo,
  code,
  headerImage,
  headerImageActive = '',
  loading = false,
  preTitle,
  title,
  sash,
  description,
  descriptions,
  openDialog,
  price,
  contractLength,
  priceIncreaseTagline = [''],
  afterPrice,
  noDiscount,
  selectButton,
  index,
  offer,
  color,
  switchTheme = false,
  showCounter = false,
  offerCount,
  onOfferSelect,
  onOfferUnSelect,
  showLoader,
  isBroadband = false,
  isTv = false,
  isMobile = false,
  handsetPrice,
  offerCardButtonDisable = false,
  afterPricePosition,
  // slideNumber,
  styleCard,
  singleTariffHeaderImage,
  singleHeaderImgDescription,
  cmsData,
  isAddon,
}) => {
  const theme = useTheme(color);
  const [style, setStyle] = useState(styles(theme, color));
  const [cardHovered, setCardHovered] = useState(false);

  useEffect(() => {
    const updatedStyle = { ...styles(theme, color), ...styleCard };
    setStyle(updatedStyle);
  }, [styleCard, color]);

  return (
    <Stack
      sx={styles(theme).mainSingleContainer}
      onMouseEnter={() => {
        setCardHovered(true);
      }}
      onMouseLeave={() => {
        setCardHovered(false);
      }}
    >
      <Grid container>
        {topTag?.length > 0 && (
          <Grid item xs={5}>
            <Box
              sx={
                topTag?.length > 0
                  ? styles(theme).topTag
                  : [styles(theme).topTag, { bgcolor: 'transparent' }]
              }
              className='swiper-no-swiping'
            >
              <Typography
                dangerouslySetInnerHTML={{ __html: topTag }}
                sx={{
                  fontFamily: theme.typography.h1.fontFamily,
                  lineHeight: '2.0',
                  color: theme.palette.secondary.contrastText,
                }}
              />
            </Box>
          </Grid>
        )}
        <Grid item xs={12}>
          <Box sx={styles(theme).boxSingleContainer} id={code}>
            <Card
              sx={{
                ...(offerSelected === false &&
                  (switchTheme === false
                    ? { borderColor: theme?.palette.primary.offerMain }
                    : { borderColor: theme?.palette.primary.OfferSelected })),
                ...(offerSelected === true &&
                  (switchTheme === false
                    ? { borderColor: theme?.palette.primary.OfferSelected }
                    : { borderColor: theme?.palette.primary.offerMain })),
                ...(moreInfo?.length === 0 ? { borderRadius: '10px' } : {}),
                ...(offerSelected && !isTv
                  ? { ...styles(theme, color)?.singleStyledCardSelected }
                  : {}),
                ...{ ...styles(theme, color)?.singleStyledCard },
              }}
            >
              <Grid container>
                <Grid item xs={5}>
                  <EirSingleCardimage
                    {...{
                      preTitle,
                      title,
                      headerImage,
                      singleTariffHeaderImage,
                      singleHeaderImgDescription,
                    }}
                    loading={loading}
                    offerSelected={offerSelected}
                    color={color}
                    switchTheme={switchTheme}
                    headerImageActive={headerImageActive}
                    cardHovered={cardHovered}
                    isBroadband={isBroadband}
                  />
                </Grid>
                <Grid item xs={7} sx={{ pb: 1, mb: 1 }}>
                  <EirSingleCardBody
                    title={title}
                    sash={sash}
                    loading={loading}
                    offerSelected={offerSelected}
                    description={description}
                    priceIncreaseTagline={priceIncreaseTagline}
                    descriptions={descriptions}
                    openDialog={openDialog}
                    price={price}
                    contractLength={contractLength}
                    afterPrice={afterPrice}
                    noDiscount={noDiscount}
                    selectButton={selectButton}
                    index={index}
                    offer={offer}
                    color={color}
                    switchTheme={switchTheme}
                    showCounter={showCounter}
                    offerCount={offerCount}
                    onOfferSelect={onOfferSelect}
                    onOfferUnSelect={onOfferUnSelect}
                    code={code}
                    showLoader={showLoader}
                    isBroadband={isBroadband}
                    isTv={isTv}
                    isMobile={isMobile}
                    handsetPrice={handsetPrice}
                    offerCardButtonDisable={offerCardButtonDisable}
                    cmsData={cmsData}
                    isAddon={isAddon}
                  />
                </Grid>
              </Grid>
              <EirSingleOfferCardFooter
                title={title}
                moreInfo={moreInfo}
                style={style.footer}
                loading={loading}
                offerSelected={offerSelected}
                afterPricePosition={afterPricePosition}
                color={color}
                switchTheme={switchTheme}
                // slideNumber={slideNumber}
                isTv={isTv}
              />
            </Card>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
};
export default EirSingleOfferCard;
